import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Attachment(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, sx, viewBox, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Attachment", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M35.25 13.5v15a3 3 0 0 1-.922 2.16 3 3 0 0 1-2.078.84H9.75a3 3 0 0 1-2.759-1.826A3 3 0 0 1 6.75 28.5v-15a3 3 0 0 1 3-3h22.5a3 3 0 0 1 3 3Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.secondary.main,
        d: "M34.26 11.25 21 22.5 7.74 11.25a3 3 0 0 1 2.01-.75h22.5a3 3 0 0 1 2.01.75Z"
      }
    ),
    /* @__PURE__ */ jsx("path", { fill: theme.vars.palette.primary.dark, d: "M32.25 38.25a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        fill: theme.vars.palette.secondary.main,
        d: "M30.953 35.197a4.125 4.125 0 0 1-2.918-7.042l3.982-3.975a3 3 0 0 1 4.238 4.245L32.25 32.4a1.927 1.927 0 0 1-2.655 0 1.883 1.883 0 0 1 0-2.655l3.585-3.578a.75.75 0 1 1 1.057 1.066L30.66 30.81a.368.368 0 0 0-.084.406c.02.045.048.085.084.119a.374.374 0 0 0 .532 0l3.975-3.983a1.499 1.499 0 0 0-.486-2.447 1.502 1.502 0 0 0-1.636.325L29.1 29.25a2.639 2.639 0 0 0 3.75 3.712l3.578-3.585a.75.75 0 0 1 1.057 1.066l-3.578 3.577a4.12 4.12 0 0 1-2.954 1.177Z"
      }
    )
  ] });
}
Attachment.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Attachment"
};
validateTidalLicense();
export {
  Attachment
};
//# sourceMappingURL=Attachment.js.map
